import { type Locale } from 'antd/lib/locale-provider'
import { type PickerLocale } from 'antd/es/date-picker/generatePicker'
import fr from 'antd/lib/locale/fr_FR'
import es from 'antd/lib/locale/es_ES'

export const SUPPORTED_LOCALES = ['fr', 'es'] as const
export type SupportedLocale = typeof SUPPORTED_LOCALES[number]
export const DEFAULT_LOCALE: SupportedLocale = 'es'

type LocaleUiConfig = {
  antd: Locale
  datePicker: PickerLocale | undefined
}

const REGISTRY: Record<SupportedLocale, LocaleUiConfig> = {
  fr: {
    antd: fr,
    datePicker: fr.DatePicker
  },
  es: {
    antd: es,
    datePicker: es.DatePicker
  }
}

export const resolveLocale = (rawLocale?: string | null): SupportedLocale => {
  const normalized = rawLocale?.toLowerCase().split(/[-_]/)[0]
  if (normalized && SUPPORTED_LOCALES.includes(normalized as SupportedLocale)) {
    return normalized as SupportedLocale
  }

  return DEFAULT_LOCALE
}

export const getLocaleUi = (locale: string): LocaleUiConfig => REGISTRY[resolveLocale(locale)]

// Aligné sur MarketRegistry (geocoder_countries). Google Places : code ISO alpha-2.
export const googlePlacesCountries = (locale: SupportedLocale): string[] =>
  locale === 'fr' ? ['fr'] : ['es', 'ad']

// "Nom 2" (deuxième nom de famille) : usage espagnol uniquement.
export const hasSecondSurname = (locale: SupportedLocale): boolean => locale === 'es'

// Exemples de saisie téléphone par marché (format local).
export const phonePlaceholders = (locale: SupportedLocale): { mobile: string, phone: string } =>
  locale === 'fr'
    ? { mobile: 'Ex: 06 12 34 56 78', phone: 'Ex: 01 23 45 67 89' }
    : { mobile: 'Ex: 650950950', phone: 'Ex: 950950950' }

export const qualimetrieWebsiteUrl = (locale: SupportedLocale): string =>
  `https://www.qualimetrie.com/${locale}`

export const localeSelectOptions = (t: (key: string) => string): Array<{ label: string, value: SupportedLocale }> =>
  SUPPORTED_LOCALES.map((locale) => ({
    label: t(`words.${locale}_locale`),
    value: locale
  }))
